import { utcToJSDate } from "@/utils/date-time";
import { BaseLookupModel, PaginationFilterRequest } from "./core.model";
import { RunningClub } from "./running-club.model";

export enum ClubEventVisibilityEnum {
  Public = 1,
  Private = 2,
}

export const ClubEventVisibilityList = [
  { value: 1, label: "Public" },
  { value: 2, label: "Private" },
];

export enum ClubEventStatusEnum {
  Draft = 1,
  Active = 2,
  Finished = 3,
  Canceled = 4,
}

export const ClubEventStatusList = [
  { value: 1, label: "Draft" },
  { value: 2, label: "Active" },
  { value: 3, label: "Finished" },
  { value: 4, label: "Canceled" },
];

export function runningClubEventFromJson<T extends RunningClubEvent | RunningClubEventList> (json: any): T {
  return {
    ...json,
    startTime: utcToJSDate(json.startTime)!,
    endTime: utcToJSDate(json.endTime),
    localStartTime: utcToJSDate(json.localStartTime),
    localEndTime: utcToJSDate(json.localEndTime),
  } as T;
};

export interface RunningClubEvent {
    id: number;
    name: string;
    description?: string;
    coverImage?: string;
    startTime: Date;
    endTime?: Date;
    localStartTime?: Date;
    localEndTime?: Date;
    startLat?: number;
    startLng?: number;
    endLat?: number;
    endLng?: number;
    startAddress?: string;
    jsonPath?: string;
    visibility: ClubEventVisibilityEnum;
    status: ClubEventStatusEnum;
    customRoleIds: number[];
    runningClubId: number;
    externalSourceUrl?: string;
    isConfirmedByClub: boolean;
    /** Free-text perks for attendees (sponsor gifts etc.). Blank becomes null server-side. */
    perks?: string;
}

export interface RunningClubEventList {
    id: number;
    name: string;
    coverImage?: string;
    startTime: Date;
    endTime?: Date;
    visibility: ClubEventVisibilityEnum;
    status: ClubEventStatusEnum;
    hasRoute: boolean;
    runningClubId: number;
    runningClub?: BaseLookupModel;
    ianaTimeZoneId?: string;
    externalSourceUrl?: string;
    isConfirmedByClub: boolean;
}

export interface UpsertRunningClubEvent {
    id?: number;
    name?: string;
    description?: string;
    coverImage?: string;
    startTime?: Date;
    endTime?: Date;
    startLat?: number;
    startLng?: number;
    endLat?: number;
    endLng?: number;
    startAddress?: string;
    jsonPath?: string;
    // Always sent: an omitted non-nullable enum binds to 0 server-side and fails validation.
    visibility: ClubEventVisibilityEnum;
    status: ClubEventStatusEnum;
    customRoleIds?: number[];
    runningClubId?: number;
    runningClub?: RunningClub;
    perks?: string;
}

export class RunningClubEventPaginationFilterRequest extends PaginationFilterRequest{
    runningClubId?: number;
}
export class RunningClubEventUsersPaginationFilterRequest extends PaginationFilterRequest{
    runningClubId?: number;
}
